import React from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DescriptionIcon from "@mui/icons-material/Description";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { TabPanel } from "./TabPanel";
import { ResponseInfo } from "./ResponseInfo";
import { ExitPlan } from "./ExitPlan";
import { AffectedProducts } from "./AffectedProducts";

export const ResponseDetails = ({
  member,
  responseSubTabValue,
  onSubTabChange,
  approvingManagers = [],
  exitRequestId,
}) => {
  const status =
    member?.hasResponded && member?.response?.status
      ? member?.response?.status
      : "PENDING";
  const hasExitPlanTab = member?.response?.isCompliant === false;

  if (member == null || member == undefined)
    return <Box sx={{ p: 3, textAlign: "center" }}></Box>;
  else if (status == "PENDING")
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <HourglassEmptyIcon fontSize="large" color="warning" sx={{ mb: 2 }} />
        <Typography variant="h6">Pending Impact Assessment</Typography>
        <Typography variant="body1" color="textSecondary">
          {member?.username} has not responded to this request yet.
        </Typography>
      </Box>
    );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          overflow: "hidden",
        }}
      >
        {/* Tabs - fixed position with smaller height */}
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "#f5f5f5",
            flexShrink: 0, // Prevent tabs from shrinking
          }}
        >
          <Tabs
            value={responseSubTabValue}
            onChange={onSubTabChange}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            sx={{
              minHeight: "36px", // Even smaller height
              "& .MuiTab-root": {
                minHeight: "36px", // Even smaller height
                py: 0.5, // Reduced padding
                fontSize: "0.85rem", // Smaller font size
              },
            }}
          >
            <Tab
              icon={<DescriptionIcon />}
              iconPosition="start"
              label="Impact Assessment Details"
            />
            {hasExitPlanTab && (
              <Tab
                icon={<ExitToAppIcon />}
                iconPosition="start"
                label="Exit Plan"
              />
            )}
          </Tabs>
        </Box>

        {/* Scrollable content area */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            overflowX: "hidden",
            px: 2,
            py: 1,
            pr: 2.5,
          }}
        >
          <TabPanel value={responseSubTabValue} index={0}>
            <ResponseInfo member={member} />
            <Box sx={{ mt: 3 }}>
              <AffectedProducts member={member} />
            </Box>
          </TabPanel>

          {hasExitPlanTab && (
            <TabPanel value={responseSubTabValue} index={1}>
              {/* Sort exit plans by id before passing to ExitPlan */}
              <ExitPlan
                member={{
                  ...member,
                  response: {
                    ...member.response,
                    exitPlans: Array.isArray(member.response?.exitPlans)
                      ? [...member.response.exitPlans].sort((a, b) => a.id - b.id)
                      : member.response?.exitPlans
                  }
                }}
                approvingManagers={approvingManagers}
                exitRequestId={exitRequestId}
              />
            </TabPanel>
          )}
        </Box>
      </Box>
    </Box>
  );
};
